import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPersonMaleFormal = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M8 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-6 8v-3a3 3 0 0 1 3-3h1.5l1 4h1l1-4H11a3 3 0 0 1 3 3v3z"
	})
});
export default SvgPersonMaleFormal;
